import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import MoviesMediaUI from '../CommonComponents/MoviesMediaUI';
import * as Links from '../../links/linksHome';
import * as UrlType from '../../constants/UrlByTypeCategories';

class MoviesMedia extends Component {


    showContentMovie = dataMedias => {
        let result = [];
        if (dataMedias.length) {
            for (let indexDataType in dataMedias) {
                result.push(
                    <Link to={ '/media/watch/' + dataMedias[indexDataType].id } key={ indexDataType } >
                        <MoviesMediaUI dataMedias={ dataMedias[indexDataType] } />
                    </Link>
                );
            }
        }
        return result.length ? result : <span className="text-center">Không có medias nào trong danh sách</span>;
    }

    handleCommonUrl = () => {
        let { dataCategory: { type } } = this.props;
        let resultUrl = '';
        if (type) {
            switch (type) {
                case UrlType.URL_MOVIE:
                    resultUrl = Links.LINK_MOVIE.path;
                    break;
                case UrlType.URL_TV_CHANEL:
                    resultUrl = Links.LINK_TV_CHANEL.path;
                    break;
                case UrlType.URL_TV_SHOW:
                    resultUrl = Links.LINK_TV_SHOW.path;
                    break;
                case UrlType.URL_SPORTS:
                    resultUrl = Links.LINK_SPORTS.path;
                    break;
                case UrlType.URL_OTHER:
                    resultUrl = Links.LINK_OTHER.path;
                    break;
                default: break;
            }
        }
        return resultUrl;
    }

    render() {

        let settingsSlickMovies = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToScroll: 8,
            slidesToShow: 8,
            responsive: [
                {
                    breakpoint: 1650,
                    settings: {
                      slidesToShow: 6,
                      slidesToScroll: 6,
                      dots: true
                    }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
        };

        let { dataCategory } = this.props;
        let commonUrl = this.handleCommonUrl();
        return (
            <div className="block-index-movie">
                <div className="container" style={{ padding: 0 }}>
                    <div className="block-index">
                            <div className="block-index-movie">
                                <div className="container">
                                    <div className="block-index-title text-blue">
                                        <Link to={ commonUrl }>{ dataCategory.name }</Link>
                                    </div>
                                    <div className="index-movie-slick block-index-common">
                                        <Slider {...settingsSlickMovies}>
                                            { this.showContentMovie(dataCategory.medias) }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MoviesMedia;



// WEBPACK FOOTER //
// ./src/components/HomeComponents/MoviesMedia.js